import { memo } from "react";
import { generatePath, Link } from "react-router";

import { cn } from "@/lib/chillnn/cn";
import type { HotelTopQuery } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { StepHeader } from "../_step-header";
import { TodoListSectionItem } from "../_todo-list-section-item";
import { TodoListSectionWrapper } from "../_todo-list-section-wrapper";
import { TodoListWrapper } from "../_todo-list-wrapper";

type Props = {
	startGuide: HotelTopQuery["startGuide"];
	disabled: boolean;
};

const HOTEL_POLICY_NOT_REGISTERED_MESSAGE = "ホテルポリシーの設定をしてください";

const FAQ_DESIGN_DIFFERENCE_NOTION_ID = "25cfffe15c57802b8293f5e4de6921f2";

export const Step4 = memo(
	({ startGuide: { hotelID, isHotelPolicyRegistered, isPlainRegistered }, disabled }: Props) => {
		return (
			<div className={cn("space-y-4", disabled && "pointer-events-none opacity-30")}>
				<StepHeader title="Step4" description="予約ページの作成" />

				<TodoListWrapper>
					<TodoListSectionWrapper>
						<p className="px-2 text-sm text-zinc-600">
							以下のいずれかのデザインを作成してください。（マガジンのみ使用する場合は、新規で作成する必要はありません）
						</p>
						<p className="px-2 text-sm text-zinc-600">
							デザインの違いについては、
							<Link
								to={generatePath(PATHS.FAQ_DETAIL, {
									hotelID,
									notionID: FAQ_DESIGN_DIFFERENCE_NOTION_ID,
								})}
								className="text-link-400 underline underline-offset-2 hover:no-underline"
							>
								こちら
							</Link>
							をご確認ください。
						</p>
						<TodoListSectionItem
							title="プレーン"
							transitionCondition={isHotelPolicyRegistered}
							alertMessageWhenNotTransition={HOTEL_POLICY_NOT_REGISTERED_MESSAGE}
							pagePath={generatePath(PATHS.HOTEL.RESERVATION_PAGE.BASE, { hotelID })}
							checkBoxStatus={isPlainRegistered}
							showCheckBox={false}
						/>
						<TodoListSectionItem
							title="マガジン"
							transitionCondition={isHotelPolicyRegistered}
							alertMessageWhenNotTransition={HOTEL_POLICY_NOT_REGISTERED_MESSAGE}
							pagePath={generatePath(PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.LIST.HOTEL, { hotelID })}
							checkBoxStatus={false}
							showCheckBox={false}
						/>
						<TodoListSectionItem
							title="スナック"
							transitionCondition={isHotelPolicyRegistered}
							alertMessageWhenNotTransition={HOTEL_POLICY_NOT_REGISTERED_MESSAGE}
							pagePath={generatePath(PATHS.HOTEL.RESERVATION_PAGE.SNACK.LIST, { hotelID })}
							checkBoxStatus={false}
							showCheckBox={false}
						/>
					</TodoListSectionWrapper>
				</TodoListWrapper>
			</div>
		);
	},
);

Step4.displayName = "Step4";
